import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { IActionItem } from 'src/Definitions';
import ActionStatuses from 'src/utils/ActionStatuses';

interface IActionItemsProps {
    dataTableManager?: IDataTableManager<IActionItem>;
    getColumnSettingsAndActionItems?: () => void;
}

class ActionItems extends React.Component<IActionItemsProps> {
    private rowCellStyleFunction(data: IActionItem) {
        if (data.dueDate < new Date() && data.status.name !== ActionStatuses.Completed.name) {
            return { color: '#dc220d', fontWeight: 'bold' } as React.CSSProperties;
        }
        return {} as React.CSSProperties;
    }

    public render() {
        return (
            <>
                <ESDataTableWithHeader
                    dataTableManager={this.props.dataTableManager!}
                    enableReorderColumns={false}
                    enableEdit={false}
                    enableSearch={false}
                    enableShowInactives={false}
                    enableToggleColumns={false}
                    rowsPerPage={5}
                    title="Actions"
                    rowCellStyleFunction={this.rowCellStyleFunction}
                />
            </>
        );
    }
}

export default ActionItems;



// WEBPACK FOOTER //
// ./src/dashboardRows/ActionItemRow/ActionItemTable/ActionItems.tsx